/* eslint-disable */

import api from "../api/api";
import Toast from "../common/Toast";
import AccountView from "../views/AccountView";
import ThankyouView from "../views/ThankyouView";
import router from "@/router";

export async function checkEmailValid({ commit }, request) {
  commit("setEmailValid", null);
  await api
    .checkEmailVal(request)
    .then((response) => {
      if (response && response?.status && response?.status === 200) {
        commit("setEmailValid", JSON.stringify(response?.data));

      }
    })
    .catch((err) => {
      console.log(err);
      commit("setEmailValid", []);
    });
}

export async function initiateVerifyEmail({ commit }, request) {
  await api
    .sendVerifyEmail(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        if (response.data.status) {
          Toast.showToast(response.data.message, "S");
          router.push({name:"EmailSent"});
          commit("setUser", JSON.stringify({firstName:request.firstName, lastName:request.lastName}));
          // AccountView.methods.respVerifyEmail();
        } else {
          Toast.showToast(response.data.message, "E");
        }
        commit("setVerifyEmailResponse", response.data.message);
      }
    })
    .catch((err) => {
      console.log(err);
      Toast.showToast("Email Not Sent", "E");
    });
}

export async function getUser({ commit }, request) {
  await api
    .getUserRequest(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setUser", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setUser", null);
    });
}

export async function getAbandonmentStatus({ commit }, request) {
  await api
    .accountRegistrationAbandonment(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        if (response.data.message) {
          commit("setAbandonmentStatus", JSON.stringify(response.data));
          Toast.showToast(response.data.message, "S");
        }
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setAbandonmentStatus", null);
    });
}

export async function getDropdownRadio({ commit }) {
  await api
    .getEnumTypes()
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit(
          "setMembershipTypes",
          JSON.stringify(response.data.userMembershipTypes)
        );
        commit(
          "setOrganizationTypes",
          JSON.stringify(response.data.organizationTypes)
        );
        commit(
          "setImisUserMembershipType",
          JSON.stringify(response.data.imisUserMembershipType)
        );
        commit(
          "setImisOrgMembershipType",
          JSON.stringify(response.data.imisOrgMembershipType)
        );
        commit(
          "setOrganizationProgressTypes",
          JSON.stringify(response.data.organizationProgressTypes)
        );
        commit(
          "setUserProgressTypes",
          JSON.stringify(response.data.userProgressTypes)
        );
        commit(
          "setMembershipLevel",
          JSON.stringify(response.data.userMembershipLevel)
        );
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setMembershipTypes", []);
      commit("setOrganizationTypes", []);
      commit("setMembershipLevel", []);
    });
}
export async function getCountries({ commit }) {
  await api
    .getCountries()
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setCountries", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setCountries", []);
    });
}

export async function checkOfacValid({ commit }, request) {
  commit("setOfacValid", null);
  await api
    .checkOfacVal(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setOfacValid", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setOfacValid", []);
    });
}

export async function initiateCreateUserOrg({ commit }, request) {
  await api
    .createUserAndOrganization(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        if (response.data.status) {
          Toast.showToast(response.data.message, "S");
        } else {
          Toast.showToast(response.data.message, "E");
        }
        commit("createUserOrgResponse", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      Toast.showToast("An error occurred, please try again", "E");
    });
}

export async function getOrganizationList({ commit }, request) {
  await api
    .getOrganizationList(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setOrganizationList", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setOrganizationList", []);
    });
}

export async function getDomainsByOrganization({ commit }, request) {
  await api
    .getDomainsByOrganization(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setDomainsByOrganization", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setDomainsByOrganization", []);
    });
}

export function initiateDocusign({ commit, dispatch }, type) {
  if (type === "EMAIL") {
    dispatch("sendDocusignEmailForSignature");
  } else {
    dispatch("initiateEmbeddedSigning");
  }
  commit("setDocusignInitiated");
}

export async function getDocusignAccessToken({ commit, dispatch }, request) {
  await api
    .getDocuSignAccessToken(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setDocusignAccessToken", JSON.stringify(response.data));
        let req = {
          token: response.data.access_token,
          type: request.type,
        };
        dispatch("getDocusignUserInfo", req);
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setDocusignAccessToken", null);
    });
}

export async function getDocusignUserInfo({ commit, dispatch }, request) {
  await api
    .getDocuSignUserInfo(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setDocusignUserInfo", JSON.stringify(response.data));
        if (request.type === "EMAIL") {
          dispatch("sendDocusignEmailForSignature");
        } else {
          dispatch("initiateEmbeddedSigning");
        }
      }
    })
    .catch((err) => {
      console.log(err);
      commit("setDocusignUserInfo", null);
    });
}

export async function sendDocusignEmailForSignature({ rootState }) {
  let req = {
    email: JSON.parse(rootState.user).email,
    type: "EMAIL",
  };

  await api
    .initiateSigning(req)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        Toast.showToast("DocuSign Email sent successfully", "S");
        ThankyouView.methods.respVerifyDocuSignEmail();
      }
    })
    .catch((err) => {
      console.log(err);
      Toast.showToast("Error occurred while sending DocuSign Email", "E");
    });
}

export async function initiateEmbeddedSigning({ rootState }) {
  let req = {
    email: JSON.parse(rootState.user).email,
    type: "INLINE",
  };

  await api
    .initiateSigning(req)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        Toast.showToast("DocuSign signing view initiated successfully", "S");
        window.open(response.data.url, "_self");
      }
    })
    .catch((err) => {
      Toast.showToast(
        "Error occurred during DocuSign signing view initiation",
        "E"
      );
      console.log(err);
    });
}

export async function updateDocusignProgress({ commit }, request) {
  await api
    .updateDocusignProgress(request)
    .then((response) => {
      if (response && response.status === 200 && response.status) {
        commit("setUser", JSON.stringify(response.data));
      }
    })
    .catch((err) => {
      Toast.showToast("Error occurred while updating docusign status", "E");
      console.log(err);
    });
}

export async function updateToken({ commit }, token) {
  commit("setToken", token);
}
export async function updateAuthcode({ commit }, authcode) {
  commit("setAuthCode", authcode);
}
export async function ssoAuthentication() {
  api.ssoAuthentication();
}
export function ssoSignout({ commit, rootState }) {
  let token = rootState.userToken;
  commit("setToken", null);
  api.ssoSignout(token);
}
export async function getAccessToken({ commit, dispatch }, token) {
                commit('setTokenStartTime', new Date().getTime());
                commit('setToken',JSON.stringify( token));
                commit('setTokenStatus', true);
                dispatch('getUserInfo');
}
export async function refreshToken({ commit, rootState }) {
  await api
    .refreshToken(rootState.userToken)
    .then((response) => {
      if (response.status == 200 && response.data) {
        commit("setTokenStartTime", new Date().getTime());
        commit("setTokenStatus", true);
        commit("setToken", JSON.stringify(response.data));
      }
    })
    .catch(function (error) {
      commit("setTokenStatus", false);
      commit("setShowLoadingOnApiCall", false);
      if (error.response) {
        if (error.response.status === 400) {
          router.push("/logout");
        }
      }
    });
}

export async function getUserInfo({ commit, dispatch }) {
  api
    .getUserInfo()
    .then((response) => {
      if (response.status === 200 && response.data) {
        if (response.data.userLogo) {
          response.data.userLogo =
            "data:image/png;base64," + response.data.userLogo;
        }

        let user = response.data;
        commit("setAuthUser", JSON.stringify(user));
        dispatch("getUser", user.email);
      }
    })
    .catch((err) => {
      Toast.showToast(
        "Error occurred while getting user details from IMIS",
        "E"
      );
      console.log(err);
      router.push("/");
    });
}

export async function getUserRegistrations({ commit }, request) {
  await api
    .getUserRegistrations(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        commit("setUserRegistrations", JSON.stringify(response.data));
      }
    })
    .catch((error) => {
      if(error.response.status === 401) {
        commit("setUser", null);
          Toast.showToast(
              "Session has expired as there was no activity, please re-login",
              "E"
            );
            commit("setToken", null);
            commit('setAdminDashboardRequest',true);
            router.push("/login");
      }
    });
}

export async function downloadSignedAgreement({commit}, request) {
  commit("setDownloadStatus", true);
  await api
    .downloadSignedAgreement(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        const str = response.headers?.['content-disposition'];
        var docName = str?.split('=')[1];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        if(docName.includes('"')){
          docName = docName.replaceAll('"',"");
        }
        if(docName.includes('*')){
          docName = docName.replaceAll(',',"");
        }
        link.setAttribute('download', docName); // Set the filename and extension
        document.body.appendChild(link);
        link.click();
        commit("setDownloadStatus", false);
        Toast.showToast("Downloaded successfully","S");
      }
    })
    .catch((err) => {
      commit("setDownloadStatus", false);
      Toast.showToast("Error occurred while downloading file","E");
      console.error('Error downloading file:', err);
    });
}

export async function saveChecklist({ commit }, request) {
  await api
    .saveChecklist(request)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        Toast.showToast("Checklist saved successfully", "S");
      }
    })
    .catch((err) => {
      console.log(err);
      Toast.showToast("Error occurred, please again...", "E");
    });
}